var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cta"},[(_vm.cta_disabled)?_c('vb-button',{staticClass:"cta__btn",attrs:{"vb_options":{
      text: 'Continua',
      variant: 'info',
      icon_disabled: 'lock_v2',
      block: true,
      disabled: true
    }}}):_c('custom-link',{attrs:{"route_name":'checkout',"wrap":'a',"before_navigation":() => {
      this.$store.commit('livebkv3/hotel_details', _vm.details)
      this.$store.commit('livebkv3/update_rooms_selection', { product_quantities: {} })
    }},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('vb-button',{staticClass:"cta__btn",attrs:{"vb_options":{
          text: 'Continua',
          variant: 'info',
          block: true
        }}})]},proxy:true}])}),(_vm.cta_status.disabled)?_c('div',{class:'cta__text text-' + _vm.cta_status.variant},[_c('vb-icon',{staticClass:"cta__text-icon mr-1",attrs:{"name":'info',"color":_vm.sass(_vm.cta_status.variant),"size":14}}),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.cta_status.label)}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }